import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import RoadRed from '@static/images/road_red.svg'
import RoadBlue from '@static/images/road_blue.svg'
import RoadOrange from '@static/images/road_orange.svg'
import RoadGreen from '@static/images/road_green.svg'
import RoadBlack from '@static/images/road_black.svg'
import RoadBronze from '@static/images/road_bronze.svg'
import RoadSilver from '@static/images/road_silver.svg'
import RoadGold from '@static/images/road_gold.svg'
import RoadWhite from '@static/images/road_white.svg'
import RoadPurple from '@static/images/road_purple.svg'
import RoadMysticBlue from '@static/images/road_mysticblue.svg'
import RoadPink from '@static/images/road_pink.svg'

export const ROAD_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: RoadRed,
    [PlayerColor.Blue]: RoadBlue,
    [PlayerColor.Orange]: RoadOrange,
    [PlayerColor.Green]: RoadGreen,
    [PlayerColor.Black]: RoadBlack,
    [PlayerColor.Bronze]: RoadBronze,
    [PlayerColor.Silver]: RoadSilver,
    [PlayerColor.Gold]: RoadGold,
    [PlayerColor.White]: RoadWhite,
    [PlayerColor.Purple]: RoadPurple,
    [PlayerColor.MysticBlue]: RoadMysticBlue,
    [PlayerColor.Pink]: RoadPink,
}
